import { useState } from 'react';

export const useToggle = initialState => {
  const [isOpen, setOpen] = useState(Boolean(initialState || false));

  const toggle = () => setOpen(!isOpen);

  return [isOpen, toggle, setOpen];
};
